import { CommonModule } from '@angular/common';
import { Component, inject, OnInit, signal } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { Router, RouterModule } from '@angular/router';
import {
    GoogleTagManagerService,
    Material,
    ProductPreviewComponent,
    ShoppingcartService,
    TranslationPipe
} from '@prekog/common-ui';
import { Observable } from 'rxjs';
import { HomeConfig } from '../shared/home-config.model';
import { FindHomeConfigRequest } from '../shared/find-home-config.request';
import { DiscountedProductsWithPackagesResponse } from '../shared/discounted-products-with-packages.response';
import { SiteConfiguration } from '../shared/site-configuration.model';
import { GetDiscountedProductsWithPackagesUseCase } from '../use-cases/getdiscountedproductswithpackages/get-discounted-product-with-packages.usecase';
import { GetSiteConfigurationByKeyUseCase } from '../use-cases/getsiteconfigurationbykey/get-site-configuration-by-key.usecase';
import { OfferHeaderComponent } from '../shared/components/offerheader/offer-header.component';
import { GetHomeConfigNameUseCase } from '../use-cases/get-home-config-name.usecase';

@Component({
    selector: 'pf-discounted-product-offering',
    templateUrl: './discounted-product-offering.component.html',
    styleUrls: ['./discounted-product-offering.component.scss'],
    standalone: true,
    imports: [CommonModule, MatIconModule, TranslationPipe, RouterModule, ProductPreviewComponent, OfferHeaderComponent]
})
export class DiscountedProductOfferingComponent implements OnInit {
    discountedMaterials: Material[] = [];
    homeConfig: HomeConfig = {};
    offerLines = signal<string[]>([]);
    offerLinesActive = signal<boolean>(true);
    router = inject(Router);

    private readonly _discountedProductsWithPackagesUseCase = inject(GetDiscountedProductsWithPackagesUseCase);
    private readonly _getHomeConfigNameUseCase = inject(GetHomeConfigNameUseCase);
    private readonly _getOfferLinesUseCase = inject(GetSiteConfigurationByKeyUseCase);
    private readonly _googleTagManagerService = inject(GoogleTagManagerService);
    private readonly _shoppingcartService = inject(ShoppingcartService);

    ngOnInit(): void {
        (this._discountedProductsWithPackagesUseCase.execute({}) as Observable<DiscountedProductsWithPackagesResponse>).subscribe(
            (response) => {
                this.discountedMaterials = (response.discountedProductList as Material[]) || [];
                this.discountedMaterials.forEach((product) => {
                    product.oldPrice = product.originalPrice;
                    product.originalPrice = product.discountPrice;
                });

                this._loadHomeConfigName();
                this._getOfferLines();

                this._googleTagManagerService.viewProductItemList(this.discountedMaterials);
            }
        );
    }

    private _loadHomeConfigName(): void {
        const findHomeConfigRequest: FindHomeConfigRequest = {
            component: 'pf-discounted-products'
        };
        (this._getHomeConfigNameUseCase.execute(findHomeConfigRequest) as Observable<HomeConfig>).subscribe(
            (homeConfig) => {
                this.homeConfig = homeConfig;
            }
        );
    }

    private _getOfferLines(): void {
        (this._getOfferLinesUseCase.execute({ configurationKey: 'pf-discounted-products-lines' }) as Observable<SiteConfiguration>).subscribe(
            (config) => {
                this.offerLinesActive.set(config.active ?? true);
                this.offerLines.set(config.configurationValue ? config.configurationValue.split('\n') : []);
            }
        );
    }

    addToCartDiscountedBook(material: Material): void {
        this._initializeDiscountedProduct(material);
        this._shoppingcartService.addToCart(material);
    }

    private _initializeDiscountedProduct(material: Material): void {
        material.oldPrice = material.originalPrice;
        material.originalPrice = material.discountPrice;
    }
}
